import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { map } from 'rxjs/operators';

import { AuthenticationService } from '../services';
import { Response } from '../interfaces';
import { SESSION_STORAGE_KEYS } from '../constants';

export const riskGuard = () => {
  const authenticationService = inject(AuthenticationService);
  const router = inject(Router);

  return authenticationService.getUserInfoPayment()
    .pipe(
      map(({ payload }: Response) => {
        console.log("Additonal data screen payload:::",payload)
        if (!payload.additionalDataFetched) {
          if (new Date() < new Date(payload.notification.COMPLIANCE_DUE_DATE) && sessionStorage.getItem(SESSION_STORAGE_KEYS.skipAdditionalData) == 'true')
            return true;
          router.navigate(['/details']);
        } else if (payload?.odd?.additionalDetails?.required) {
          const stage = payload.odd?.additionalDetails?.notificationStage;
          const skipped = sessionStorage.getItem(SESSION_STORAGE_KEYS.skipAdditionalData) === 'true';
          if (stage === 1 && skipped) return true;
          router.navigate(['/details']);
        }
        // Check both iDenfy and Veriff ODD renewal requirements (parallel provider support)
        if (payload?.odd?.idenfy?.required || payload?.odd?.veriff?.required) {
          const isMandatory = payload.kyc?.status === 'PENDING';
          const skipped = sessionStorage.getItem(SESSION_STORAGE_KEYS.skipKycRenewal) === 'true'
            || sessionStorage.getItem(SESSION_STORAGE_KEYS.skipIdenfyRenewal) === 'true'; // backward compat
          if (!isMandatory && skipped) return true;
          router.navigate(['/kyc/init'], { queryParams: isMandatory ? {} : { canSkip: true } });
        }
        else if (payload.kyc?.riskApprovalStatus && (payload.kyc?.riskApprovalStatus === "BLOCKED")) {
          router.navigate(['/review']);
        }
        return true;
      })
    )
}
